export enum PropertyStrategyThemeType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Form = 'form',
  Outlined = 'outlined',
  Transparent = 'transparent',
  Search = 'search',
  DatabaseSearch = 'database-search',
  Checklist = 'checklist',
  Light = 'light',
  SidebarSearch = 'sidebar-search',
  Settings = 'settings',
  BottomSheet = 'bottom-sheet',
  Mobile = 'mobile',
}
